// Display helpers shared by the dashboard and the list tables.

export function formatDate (value, withTime = false) {
  if (!value) return '—'
  const date = new Date(typeof value === 'string' ? value.replace(' ', 'T') : value)
  if (isNaN(date.getTime())) return value
  const options = { day: '2-digit', month: 'short', year: 'numeric' }
  if (withTime) Object.assign(options, { hour: '2-digit', minute: '2-digit' })
  return date.toLocaleString('en-GB', options)
}

export function formatMoney (value, currency = 'USD') {
  if (value === null || value === undefined || value === '') return '—'
  const number = Number(value)
  if (isNaN(number)) return value
  return number.toLocaleString('en-US', { style: 'currency', currency, maximumFractionDigits: 2 })
}

// Checked in order: 'unpaid' must not read as 'paid'.
const statusColors = [
  { color: 'error', words: ['cancel', 'fail', 'reject', 'declin', 'refund', 'expired', 'error'] },
  { color: 'warning', words: ['pending', 'unpaid', 'not paid', 'initiat', 'process', 'waiting', 'hold', 'request', 'inquiry'] },
  { color: 'success', words: ['paid', 'confirm', 'success', 'complete', 'booked', 'approved', 'active', 'transferred'] }
]

// Maps a free-text booking/payment status to a Vuetify color name.
export function statusColor (status) {
  const value = String(status || '').toLowerCase()
  if (!value) return 'grey'
  const match = statusColors.find(group => group.words.some(word => value.includes(word)))
  return match ? match.color : 'grey'
}

export function statusLabel (status) {
  if (!status) return '—'
  return String(status).replace(/[_-]+/g, ' ').replace(/\b\w/g, c => c.toUpperCase())
}

export function formatWeekday (value) {
  if (!value) return ''
  const date = new Date(value)
  return isNaN(date.getTime()) ? '' : date.toLocaleDateString('en-GB', { weekday: 'long' })
}
